import gsap from "gsap";
import { MorphSVGPlugin } from "gsap/all";

export default class Navigation {
  $masthead = $("#masthead");
  $bg = this.$masthead.find(".masthead-bg");
  $logo = $("#masthead .logo svg");
  $button = $(".toggle-menu");
  $nav = $("nav#primary");
  isOpen = false;
  $els = $("a[href='#top-page']");
  backgroundColour = "#5F2467";
  logoColour = "#222a53";
  style = "dark";

  constructor() {
    this.init();
  }

  init() {
    gsap.registerPlugin(MorphSVGPlugin);

    this.style = this.$masthead.data("style");

    this.$button.on("click", () => {
      this.handleClick();
    });

    this.$els.each(function (index) {
      $(this).on("click", function () {
        window.scroll({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      });
    });

    $(document).on("click", (e) => {
      if ($(e.target).closest("#masthead").length === 0) {
        this.closeMenu();
        this.isOpen = false;
      }
    });

    window.setTimeout(() => {
      this.handleSubmenus();
    }, 200);

    this.setMastheadColour();

    this.onScroll();

    window.addEventListener("scroll", () => {
      this.onScroll();
    });

    $("#hamburger").on("click", () => {
      this.toggleMobileMenu();
    });
  }

  isTouchDevice() {
    return (
      "ontouchstart" in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0
    );
  }

  onScroll() {
    if (window.scrollY > 0) {
      this.$masthead.addClass("is-scrolled");
      this.pulldownMasthead();
    } else {
      this.$masthead.removeClass("is-scrolled");
      this.regularMasterhead();
    }
  }

  setMastheadColour() {
    this.backgroundColour = $("#masthead-bg").attr("fill");

    // Append the document with a style tag that sets the background colour of the masthead.
    const style = document.createElement("style");

    let html = `#masthead.pulldown .btn-secondary::after { background-color: ${this.backgroundColour}; } #masthead.pulldown .btn-secondary:hover { color: #fff !important; } #masthead.pulldown .btn-primary:hover {color: ${this.backgroundColour} !important;}`;

    style.innerHTML = html;

    document.head.appendChild(style);
  }

  pulldownMasthead() {
    const $logo = $(this.$masthead).find(".logo svg");
    const $navStroke = $(this.$masthead).find(".masthead-bg");

    const $btnPrimary = $(this.$masthead).find(".btn-primary");
    const $btnSecondary = $(this.$masthead).find(".btn-secondary");

    const $triangleWrapper = $(this.$masthead).find(
      ".masthead-triangle-wrapper"
    );

    const colour = $navStroke.data("pulldown-colour");

    $(this.$masthead).addClass("pulldown text-white");

    $($navStroke).css("background", colour);
    $navStroke.removeClass("lg:-translate-y-full");

    $logo.find("path").css("fill", "#fff");

    $triangleWrapper.addClass("-translate-y-full");

    $btnPrimary.css({
      "background-color": this.backgroundColour,
      "border-color": "#fff",
    });

    $btnSecondary.css({
      "border-color": "#fff",
      color: this.backgroundColour,
    });

    this.$masthead.find(".underline").addClass("bg-white");
  }

  regularMasterhead() {
    const $logo = $(this.$masthead).find(".logo svg");
    const $menuWrapper = $(this.$masthead).find(".menu-wrapper");
    const $navStroke = $(this.$masthead).find(".masthead-bg");

    const $btnPrimary = $(this.$masthead).find(".btn-primary");
    const $btnSecondary = $(this.$masthead).find(".btn-secondary");

    const $triangleWrapper = $(this.$masthead).find(
      ".masthead-triangle-wrapper"
    );

    $(this.$masthead).removeClass("pulldown text-white");

    //$($navStroke).css("background", "#fff");
    $navStroke.addClass("lg:-translate-y-full");

    if (this.style === "dark") {
      $logo.find("path").css("fill", "#222a53");
    } else {
      $logo.find("path").css("fill", "#fff");
    }

    $triangleWrapper.removeClass("-translate-y-full");

    $btnPrimary.css({ "background-color": "", "border-color": "" });

    $btnSecondary.css({
      "border-color": "",
      color: "",
    });

    this.$masthead.find(".underline").removeClass("bg-white");
  }

  handleClick() {
    if (!this.isOpen) {
      this.openMenu();
      this.isOpen = true;
    } else {
      this.closeMenu();
      this.isOpen = false;
    }
  }

  openMenu() {
    gsap.to(this.$nav, {
      duration: 0.5,
      height: this.$nav.find(".inner").height() + 100,
      opacity: 1,
      ease: "power2.out",
    });
  }

  closeMenu() {
    gsap.to(this.$nav, {
      duration: 0.5,
      height: "0vh",
      opacity: 0,
      ease: "power2.out",
    });
  }

  handleSubmenus() {
    $("#main-menu .menu-item-has-children > .menu-link").on("click", (e) => {
      const $target = $(e.currentTarget);
      const $subMenu = $target.siblings(".sub-menu");

      console.log($subMenu);

      if (this.isTouchDevice()) {
        console.log("Touch device");
        e.preventDefault();
      }

      if (!$subMenu.hasClass("is-open")) {
        this.openSubmenu($subMenu);
      } else {
        this.closeSubmenu($subMenu);
      }
    });

    $("#main-menu .menu-item-has-children").on("mouseenter", (e) => {
      e.preventDefault();

      const $target = $(e.currentTarget);
      const $subMenu = $target.find(".sub-menu");

      $target.closest("li").addClass("is-hovered");

      // Close all other menus.
      $(e.currentTarget)
        .parent()
        .siblings(".menu-item-has-children")
        .each((index, item) => {
          this.closeSubmenu($(item).find(".sub-menu"));
        });

      if (!$subMenu.hasClass("is-open")) {
        this.openSubmenu($subMenu);
      }
    });

    $(".menu-item-has-children").on("mouseleave", (e) => {
      e.preventDefault();

      const $target = $(e.currentTarget);
      const $subMenu = $target.find(".sub-menu");

      $target.closest("li").removeClass("is-hovered");

      if ($subMenu.hasClass("is-open")) {
        this.closeSubmenu($subMenu);
      }
    });

    // If the user clicks on the body, close all submenus.
    $("body").on("mouseenter", (e) => {
      if (!$(e.target).closest("#main-menu .sub-menu").length) {
        this.closeAllSubmenus();
      }
    });
  }

  openSubmenu(submenu) {
    let targetHeight = 10;

    // Calculate the target height of the submenu
    // by adding up the height of all list items.
    $(submenu)
      .find("li")
      .each(function (index) {
        targetHeight += $(this).outerHeight();
      });

    this.$bg.css(
      "height",
      targetHeight + $(this.$masthead).outerHeight() - 20 + "px"
    );

    gsap.to(submenu.get(0), {
      duration: 0.5,
      height: targetHeight,
      ease: "power2.out",
    });

    $(submenu).addClass("is-open");
    $(submenu).siblings("a").addClass("active");
  }

  closeSubmenu(submenu) {
    gsap.to(submenu.get(0), {
      duration: 0.5,
      height: 0,
      ease: "power2.out",
    });

    this.$bg.css("height", "100px");

    $(submenu).removeClass("is-open");
    $(submenu).siblings("a").removeClass("active");
  }

  closeAllSubmenus(ignore = null) {
    $("#main-menu .sub-menu").each(function (index, submenu) {
      if (submenu === ignore) {
        return;
      }

      gsap.to($(submenu).get(0), {
        duration: 0.5,
        height: 0,
        ease: "power2.out",
      });

      $(submenu).removeClass("is-open");
      $(submenu).siblings("a").removeClass("active");
    });
  }

  toggleMobileMenu() {
    $("#mobile-menu-wrapper").toggleClass("-translate-x-[102%]");
    $("#mobile-menu-fader").toggleClass("opacity-60 opacity-0");

    // Animate burger to a cross.

    const $burger = $("#hamburger");

    if (!$("#mobile-menu-wrapper").hasClass("-translate-x-[102%]")) {
      gsap.to($burger.find("span:nth-child(1)"), {
        duration: 0.3,
        rotate: 45,
        y: 8,
        ease: "power2.out",
      });

      gsap.to($burger.find("span:nth-child(2)"), {
        duration: 0.3,
        width: 0,
        x: 20,
        ease: "power2.out",
      });

      gsap.to($burger.find("span:nth-child(3)"), {
        duration: 0.3,
        rotate: -45,
        y: -10,
        ease: "power2.out",
      });
    } else {
      gsap.to($burger.find("span:nth-child(1)"), {
        duration: 0.3,
        rotate: 0,
        y: 0,
        ease: "power2.out",
      });

      gsap.to($burger.find("span:nth-child(2)"), {
        duration: 0.3,
        width: "100%",
        x: 0,
        ease: "power2.out",
      });

      gsap.to($burger.find("span:nth-child(3)"), {
        duration: 0.3,
        rotate: 0,
        y: 0,
        ease: "power2.out",
      });
    }
  }
}
